import { ImportSpecsPDF } from "./ImportSpecsPDF";

export default ImportSpecsPDF;
